import { __extends } from "tslib";
/**
 * Created by Adam Dziewirz on 2018-11-20
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import template from '../template/filter.hbs';
import filterTemplateButtons from '../template/filter-buttons.hbs';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
import BSSMultivalueManagerComponent from '@main/view/components/bss-multivalue-manager-component/js/bss-multivalue-manager-component';
import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSFilterComponent class
 */
var templateObject = {
    defaultTemplate: template,
};
var BSSFilterComponent = /** @class */ (function (_super) {
    __extends(BSSFilterComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     */
    function BSSFilterComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        /**
         * @desc set error flag for the entity error
         * @private
         */
        _this._setErrorFlag = function () {
            logger.info('BSSFilterComponent' +
                _this._config.componentId +
                ' => function: _setErrorFlag');
            _this._isEntityError = true;
        };
        /**
         * @desc is called when the browser window has been resized
         * @private
         */
        _this._onWindowResize = function () {
            logger.info('BSSFilterComponent' +
                _this._config.componentId +
                ' => function: _onWindowResize');
            var filterContentSection = Array.from(document.getElementsByClassName('bss-filter_content-section-view'));
            var displayProperty = _this._resolution.getCurrent() === 'xs' ? 'none' : 'block';
            filterContentSection.forEach(function (el) { return (el.style.display = displayProperty); });
        };
        /**
         * @desc trigger on show or hide filter container
         * @private
         */
        _this._showHideAdvancedFilter = function () {
            var _a;
            logger.info('BSSFilterComponent: ' +
                _this._config.componentId +
                ' => function : _showHideAdvancedFilter');
            var isFiltersActive = _this._$componentContent.hasClass('is-active');
            _this._$componentContent.slideToggle(_this._animDuration);
            _this._$componentContent.toggleClass('is-active', !isFiltersActive);
            _this._$buttonShowHideFilter
                .find('.bss-filter_btn-hide-show-text')
                .text(isFiltersActive ? _this._showText : _this._hideText);
            _this._$buttonShowHideFilter
                .find('.bss-filter_arrow-icon')
                .toggleClass('bss-filter_arrow-transform', isFiltersActive);
            var configTagEvent = ((_a = _this._config) === null || _a === void 0 ? void 0 : _a.tagEvent) || {};
            var additionalFiltersOpenTagEvent = configTagEvent.additionalFiltersOpenTagEvent, additionalFiltersCloseTagEvent = configTagEvent.additionalFiltersCloseTagEvent;
            var tagEvent = isFiltersActive
                ? additionalFiltersCloseTagEvent
                : additionalFiltersOpenTagEvent;
            _this._onTaggingEvent(tagEvent === null || tagEvent === void 0 ? void 0 : tagEvent.throwEvent, tagEvent === null || tagEvent === void 0 ? void 0 : tagEvent.throwAfterCalculation);
        };
        if (_this._config.hintText || _this._config.hintTitle) {
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', config, eventManager, formatter, resolution, toolbox);
        }
        _this._componentVersion = '@@name ver. @@version';
        logger.info('Component ' + _this._config.componentId + ' has been successful render');
        _this._entityTemplate = _entityTemplate;
        _this._formatter = formatter;
        _this._resolution = resolution;
        /**
         * @desc flag for entity error
         * @type {boolean}
         * @private
         */
        _this._isEntityError = false;
        /**
         * @desc duration of slideUp and slideDown animation
         * @type {Number}
         * @private
         */
        _this._animDuration = _this._config.animDuration
            ? _this._config.animDuration
            : 400;
        /**
         * @desc if filters are visible on init
         * @type {Boolean}
         * @private
         */
        _this._isVisibleFilter =
            typeof _this._config.isVisible !== 'undefined'
                ? _this._config.isVisible
                : true;
        /**
         * @desc filter component container (all content without toggle button)
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$componentContent = _this._entityTemplate.find('#' + _this._config.componentId + '_container');
        /**
         * @desc all filters content container (all sliders inside)
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$filtersContent = _this._$componentContent.find('.bss-filter_content-filter');
        _this._filtersContentSection = _this._$filtersContent.find('.bss-filter_content-section');
        /**
         * @desc slider content slides
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$contentSlides = _this._entityTemplate
            .find('#' + _this._config.componentId + ' .bss-filter_content-filter')
            .find('.bss-filter_content-tab');
        /**
         * @desc button toggle "filter component container"
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$buttonShowHideFilter = _this._entityTemplate
            .find('#' + _this._config.componentId)
            .find('.bss-filter_btn-toggle-filters');
        // bounded texts
        _this._hideText = _this._getBoundedString(_this._config.hideText, true);
        _this._showText = _this._getBoundedString(_this._config.showText, true);
        _this._$componentContent
            .toggle(_this._isVisibleFilter)
            .toggleClass('is-active', _this._isVisibleFilter);
        _this._$buttonShowHideFilter
            .find('.bss-filter_btn-hide-show-text')
            .text(_this._isVisibleFilter ? _this._hideText : _this._showText);
        _this._$buttonShowHideFilter
            .off('click.' + _this._config.componentId)
            .on('click.' + _this._config.componentId, _this._showHideAdvancedFilter);
        _this._eventManager.subscribe('bss-additional-change-event-' + _this._config.entityInstanceId, _this._onSliderChange.bind(_this), 'Entity-' + _this._config.entityInstanceId);
        _this._injectSliders();
        _this._addEventListeners();
        return _this;
    }
    /**
     * Add main component event listeners
     * @private
     */
    BSSFilterComponent.prototype._addEventListeners = function () {
        logger.info('BSSFilterComponent' +
            this._config.componentId +
            ' => function: _addEventListeners');
        this._window.on('resize.' + this._config.componentId, this._onWindowResize);
        this._eventManager.subscribe("bss-entity-error-".concat(this._config.entityInstanceId), this._setErrorFlag, "".concat(this.subscriberPrefix).concat(this._config.componentId));
        this._addAccordionToggleListener();
    };
    /**
     * @desc method on change filter (slider) value - triggers abstract's _onOutputChange if something changed
     * @private
     */
    BSSFilterComponent.prototype._onSliderChange = function (publisher, params) {
        var _this = this;
        logger.info('BSSFilterComponent: ' +
            this._config.componentId +
            ' => function : _onSliderChange | Params: ', publisher, params);
        var updatedParams = params[this._productId];
        var filterListResultData = JSON.parse(JSON.stringify(this._filterListResultData)); // if error comes in request, will not modify this._filterListResultData
        var objToSend = {};
        this._toolbox.$.each(updatedParams, function (paramName, paramVal) {
            var paramValue;
            if (paramName !== 'triggerName') {
                var paramPath = paramName.split('_');
                paramValue = _this._toolbox.$.isNumeric(paramVal)
                    ? parseFloat(paramVal)
                    : paramVal;
                filterListResultData[paramPath[0]][paramPath[1]] = paramValue;
            }
            else {
                paramValue = paramVal.split('_');
                objToSend.triggerName = paramValue[0];
            }
        });
        objToSend[this._config.valueDataParam] = filterListResultData;
        this._onOutputChange(objToSend);
    };
    /**
     * @desc method on filter reset
     * @private
     */
    BSSFilterComponent.prototype._onFilterReset = function (ev) {
        logger.info('BSSFilterComponent: ' +
            this._config.componentId +
            ' => function : _onFilterReset | Params: ', ev);
        var buttonClicked = this._entityTemplate.find(ev.currentTarget);
        var dataIndex = buttonClicked.data('index');
        var filterListResultData = JSON.parse(JSON.stringify(this._filterListResultData)); // if error comes in request, will not modify this._filterListResultData
        var objToSend = {};
        if (typeof dataIndex !== 'undefined') {
            filterListResultData[this._config.filterList[dataIndex].name].value =
                this._config.filterList[dataIndex].default;
        }
        else {
            this._toolbox.$.each(this._config.buttonsList, function (index, paramVal) {
                filterListResultData[paramVal.name].value = paramVal.default;
            });
        }
        ev.stopPropagation();
        objToSend[this._config.valueDataParam] = filterListResultData;
        this._onOutputChange(objToSend);
    };
    /**
     * @desc method for create ui-description of each slider
     * @private
     */
    BSSFilterComponent.prototype._createSliderDescription = function (config, filterName, index) {
        logger.info('BSSFilterComponent: ' +
            this._config.componentId +
            ' => function : _createSliderDescription | Params: ', config, filterName, index);
        if (!this._sliderComponentsDescription) {
            this._sliderComponentsDescription = [];
            this._filterSliders = [];
        }
        if (!this._sliderComponentsDescription[index]) {
            this._sliderComponentsDescription[index] = {
                componentId: 'slider_' + filterName,
                componentTemplate: 'labelWithInputTemplate',
                componentType: 'MultivalueManagerComponent',
                entityInstanceId: this._config.entityInstanceId,
                tooltips: [false],
                productId: this._config.productId,
                class: 'bss-slider_btn-hidden bss-slider_input-hidden',
                withSmallInput: false,
                title: '<value data-text=' +
                    this._productId +
                    '.' +
                    filterName +
                    ".displayText'></value>",
                variable: "<value data-formatter='" +
                    config.formatter +
                    "' data-value='" +
                    this._productId +
                    '.' +
                    filterName +
                    "_value'></value>",
                variableMax: "<value data-value='" +
                    this._productId +
                    '.' +
                    filterName +
                    "_max'></value>",
                variableMin: "<value data-value='" +
                    this._productId +
                    '.' +
                    filterName +
                    "_min'></value>",
                variableStep: "<value data-value='" +
                    this._productId +
                    '.' +
                    filterName +
                    "_step'></value>",
                minTitle: '<value>Minimum</value>',
                maxTitle: '<value>Maximum</value>',
                multivalueManagerSettings: {
                    minStepForSlider: 1,
                    sliderTagEvent: [
                        {
                            onEvent: 'update',
                            selector: '',
                            throwAfterCalculation: true,
                            throwEvent: 'multivalueComponent_modify',
                        },
                    ],
                    labelConfig: {
                        text: "<value data-formatter='" +
                            config.formatter +
                            "' data-value='" +
                            this._productId +
                            '.' +
                            filterName +
                            "_value'></value>",
                        class: 'bss-label--title bss-label--bc-slider-value',
                        valueUnderTitle: true,
                    },
                },
                notDisabledPips: true,
                newDesign: true,
                isMobileInput: false,
                popupInputResolutions: false,
                isParentDependentChild: true,
                sendAdditionalChangeEvent: true,
                onChangeOff: true,
                resultDataFilterComponent: {}, // merged with resultData in multivalueComponent's js
            };
        }
        if (filterName === 'numberOfSeats') {
            // additional config for seats slider
            this._sliderComponentsDescription[index].class =
                'bss-slider_btn-hidden bss-slider_input-hidden';
            this._sliderComponentsDescription[index].notDisabledPips = false;
            this._sliderComponentsDescription[index].slideSeats = true;
            this._sliderComponentsDescription[index].variable =
                "<value data-value='" +
                    this._productId +
                    '.' +
                    filterName +
                    "_value'></value>"; //without formattter
            this._sliderComponentsDescription[index].componentTemplate =
                'incrementerTemplate';
            this._sliderComponentsDescription[index].atLeast =
                this._config.texts.general.at_least_label;
            this._sliderComponentsDescription[index].upTo =
                this._config.texts.general.up_to_label;
            this._sliderComponentsDescription[index].seats =
                this._config.texts.general.seats_label;
        }
        this._sliderComponentsDescription[index].resultDataFilterComponent[this._productId] = {};
        this._sliderComponentsDescription[index].resultDataFilterComponent[this._productId][filterName + '_value'] = config.value;
        this._sliderComponentsDescription[index].resultDataFilterComponent[this._productId][filterName + '_min'] = config.min;
        this._sliderComponentsDescription[index].resultDataFilterComponent[this._productId][filterName + '_max'] = config.max;
        this._sliderComponentsDescription[index].resultDataFilterComponent[this._productId][filterName + '_step'] = config.step;
        if (!this._sliderComponentsDescription[index].resultData) {
            // only on filters init, generate resultData per filter
            this._sliderComponentsDescription[index].resultData = JSON.parse(JSON.stringify(this._sliderComponentsDescription[index].resultDataFilterComponent));
        }
    };
    /**
     * @desc prepares component for data binding
     * @private
     */
    BSSFilterComponent.prototype._prepareFilterConfig = function (resultData) {
        if (resultData === void 0) { resultData = this._config.resultData; }
        logger.info('BSSFilterComponent: ' +
            this._config.componentId +
            ' => function : _prepareFilterConfig');
        this._productId = this._config.productId[0];
        this._filterListResultData =
            resultData[this._productId][this._config.valueDataParam];
        this._config.filterList = [];
        this._config.buttonsList = [];
        var i = 0;
        for (var filterName in this._filterListResultData) {
            if (this._filterListResultData.hasOwnProperty(filterName) &&
                this._filterListResultData[filterName].displayText !== '' &&
                this._filterListResultData[filterName].displayText !== null) {
                var value = this._filterListResultData[filterName].value;
                var formatter = this._filterListResultData[filterName].formatter;
                var formattedValue = formatter
                    ? this._formatter.getFormattedValue(value, formatter)
                    : value;
                var visible = this._filterListResultData[filterName].visible;
                if (!visible) {
                    continue;
                }
                this._config.filterList.push({
                    name: filterName,
                    default: this._filterListResultData[filterName].default,
                    value: value,
                    displayText: this._filterListResultData[filterName].displayText,
                    additionalClass: this._filterListResultData[filterName].additionalClass,
                    formatter: formatter,
                    formattedValue: formattedValue,
                    filterIndex: i,
                });
                if (this._config.filterList[i].default !==
                    this._config.filterList[i].value) {
                    this._config.buttonsList.push({
                        name: filterName,
                        default: this._config.filterList[i].default,
                        value: this._config.filterList[i].value,
                        formattedValue: this._config.filterList[i].formattedValue,
                        filterIndex: i,
                    });
                }
                this._toolbox.currentFilterList = this._config.buttonsList;
                var firstProductId = this._config.productId[0];
                var firstProductResultData = this._config.resultData[firstProductId];
                this._toolbox.monthlyPayment = firstProductResultData.monthlyPayment;
                this._toolbox.country = firstProductResultData.country;
                this._createSliderDescription(this._filterListResultData[filterName], filterName, i);
                i++;
            }
        }
        if (this._config.filterList.length === 0) {
            this._$buttonShowHideFilter.style.contentVisibility = 'hidden';
        }
        this._filterTemplateButtons = this._toolbox.$(filterTemplateButtons(this._config));
    };
    /**
     * @desc inject sliders to filter component
     * @private
     */
    BSSFilterComponent.prototype._injectSliders = function () {
        logger.info('BSSFilterComponent: ' +
            this._config.componentId +
            ' => function : _injectSliders | Params: ');
        var _self = this;
        this._$contentSlides.each(function () {
            var index = _self._toolbox.$(this).data('index');
            _self._filterSliders[index] = new BSSMultivalueManagerComponent(_self._entityTemplate, _self._toolbox.$(this), _self._sliderComponentsDescription[+index], _self._eventManager, _self._formatter, _self._resolution, _self._toolbox);
        });
    };
    /**
     * @desc _setFiltersButtons - sets buttons corresponding to selected filters
     * @private
     */
    BSSFilterComponent.prototype._setFiltersButtons = function () {
        logger.info('BSSFilterComponent: ' +
            this._config.componentId +
            ' => function : _setFiltersButtons ');
        if (this._$filterResetButtons) {
            this._$filterResetButtons.off('click.' + this._config.componentId);
        }
        this._componentScope
            .find('.bss-filter-selected-tabs')
            .html(this._filterTemplateButtons);
        this._$filterResetButtons = this._$componentEl.find('.filters-reset-action');
        this._$filterResetButtons.on('click.' + this._config.componentId, this._onFilterReset.bind(this));
    };
    BSSFilterComponent.prototype._addAccordionToggleListener = function () {
        var filterContentHeader = this._entityTemplate.find('.bss-filter_content-section-title');
        this._toolbox.$.each(filterContentHeader, function (key, header) {
            header.addEventListener('click', function () {
                header.classList.toggle('active');
                var filterContent = header.nextElementSibling;
                filterContent.classList.toggle('active');
                if (filterContent.classList.contains('active')) {
                    filterContent.style.display = 'block';
                    header.lastElementChild.classList.add('bss-filter_arrow-transform');
                }
                else {
                    filterContent.style.display = 'none';
                    header.lastElementChild.classList.remove('bss-filter_arrow-transform');
                }
            });
        });
    };
    /**
     * BSSAbstractComponent _setConfig method override
     * @param {Object} config configuration
     * @private
     */
    BSSFilterComponent.prototype.setConfig = function (config) {
        logger.info('BSSFilterComponent: ' +
            this._config.componentId +
            ' => function : setConfig');
        _super.prototype.setConfig.call(this, config);
        this._prepareFilterConfig();
    };
    /**
     * BSSAbstractComponent method override
     * @param {String} publisherName - event owner name
     * @param {Object} data - updateObject holds new text and dataResult
     * @emits {bss-component-data-rebound-$COMPONENT-ID'}
     * @private
     */
    BSSFilterComponent.prototype.update = function (publisherName, data) {
        logger.info('BSSFilterComponent:: ' +
            this._config.componentId +
            ' => function : _update' +
            ' | Params: ', publisherName, data);
        var resultData = data.resultData[this._config.productId[0]];
        // save update timestap - for component-critical-error handling
        this._lastUpdateTimestamp = data.updateTimestamp;
        // if there is regular update event (not revert state) and critical error was thrown, do not update this component!
        if (this._stopUpdateFlag && !this._isRevertStateEvent) {
            this._stopUpdateFlag = false;
            if (typeof resultData.error_code !== 'undefined') {
                this.setErrorObject('config -> there is no complete set of data', 'critical');
                this._onCriticalError(this._errorObj);
            }
            return;
        }
        this._resetErrorObject();
        this._isRevertStateEvent = false;
        // if entity error - do not refresh data
        if (this._isEntityError) {
            this._isEntityError = false;
            return;
        }
        // details or financial details accordion click on BC - do not refresh data
        if (resultData.details) {
            return;
        }
        this.preventUpdateEvent = true;
        if (this._config.productId[0] === 'general') {
            this.productIterator = this._config.productId.length - 1;
        }
        else {
            this.productIterator = 0;
        }
        this._resetErrorObject();
        this._prepareFilterConfig(data.resultData);
        this._setFiltersButtons();
        this._validateDataOnChange(data, true, true);
        if (this._tagEventOnThrow !== null) {
            this._throwTaggingEvent(this._tagEventOnThrow, true);
            this._tagEventOnThrow = null;
        }
        this.preventUpdateEvent = false;
        this._eventManager.publish('bss-popup-recalculateOnEvent', this._config.componentType + '-' + this._config.componentId);
        this._eventManager.publish('bss-component-data-rebound-' + this._config.componentId, this._config.componentType + '-' + this._config.componentId, data);
    };
    /**
     * @desc base destroy method
     */
    BSSFilterComponent.prototype.destroy = function () {
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        for (var i = 0; i < this._filterSliders.length; i++) {
            if (this._filterSliders[i] instanceof BSSMultivalueManagerComponent) {
                this._filterSliders[i].destroy();
            }
        }
        _super.prototype.destroy.call(this);
    };
    return BSSFilterComponent;
}(BSSAbstractComponent));
export default BSSFilterComponent;
